var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.8708C0 0.838938 0.822135 0 1.83333 0H9.16667C10.1779 0 11 0.838938 11 1.8708V14.0632C11 14.8115 10.1836 15.2558 9.57344 14.8407L5.5 12.0667L1.42656 14.8407C0.816406 15.2558 0 14.8086 0 14.0632V1.8708ZM1.83333 1.4031C1.58125 1.4031 1.375 1.61357 1.375 1.8708V13.1892L4.73802 10.9033C5.19922 10.5905 5.80078 10.5905 6.26198 10.9033L9.625 13.1892V1.8708C9.625 1.61357 9.41875 1.4031 9.16667 1.4031H1.83333Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaSaveIcon);
export default __webpack_public_path__ + "static/media/InstaSaveIcon.c6771c9c56f4fbbc95c3ab0f305d8dca.svg";
export { ForwardRef as ReactComponent };